@if (multiselect()) {
    <app-multi-select-input
        [form]="form()"
        [id]="id()"
        [label]="label()"
        [disabled]="disabled()"
        [infiniteScroll]="typesScroll()"
        [group]="true"
        [showClear]="false"
        idField="name"
        valueKey="value"
        labelKey="name"
    >
        <ng-template #item let-item>
            {{ item.name }}
        </ng-template>
    </app-multi-select-input>
} @else {
    <app-select-input
        [form]="form()"
        [id]="id()"
        [label]="label()"
        [disabled]="disabled()"
        [infiniteScroll]="typesScroll()"
        [group]="true"
        [showClear]="false"
        idField="name"
        valueKey="value"
        labelKey="name"
    ></app-select-input>
}
